import { Button } from "reactstrap";
import styled from "styled-components";
import PropTypes from "prop-types";

const SubmitButtonContainer = styled.div`
  display: flex;
  margin-top: 1rem;
  justify-content: flex-end;
`;

const StyledSubmitButton = styled(Button)`
  background-color: #0078a8;
  &:hover,
  &:active {
    background-color: #0078a8;
    color: #ffffff;
  }
  color: #ffffff;
  font-size: 1rem;
  border: none;
  width: 100%;
  @media (min-width: 768px) {
    width: auto;
  }
`;

const SubmitButton = ({ children }) => {
  return (
    <SubmitButtonContainer>
      <StyledSubmitButton color="default">{children}</StyledSubmitButton>
    </SubmitButtonContainer>
  );
};

SubmitButton.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

SubmitButton.defaultProps = {
  disabled: false,
};

export default SubmitButton;
